import React from "react";
import HrLayout from "../../layouts/HrLayout";
import Card from "../../components/UI/Card";
import Button from "../../components/UI/Button";

export default function Recruitment() {
  const openings = [
    {
      id: 1,
      position: "Frontend Developer",
      department: "IT",
      jobType: "Full-Time",
      posted: "2025-02-01",
      candidates: 12,
      status: "Open",
    },
    {
      id: 2,
      position: "HR Executive",
      department: "HR",
      jobType: "Contract",
      posted: "2025-01-24",
      candidates: 5,
      status: "Closed",
    },
  ];

  const getStatusBadge = (status) => {
    const colors = {
      Open: "bg-green-100 text-green-700",
      Closed: "bg-red-100 text-red-700",
      OnHold: "bg-yellow-100 text-yellow-700",
    };
    return colors[status] || "bg-gray-100 text-gray-700";
  };

  return (
    <HrLayout>
      <div className="p-6 bg-gray-100 min-h-screen">
        
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Recruitment</h1>

          <Button
            className="bg-gradient-to-r from-blue-600 to-blue-700 hover:opacity-90 text-white shadow-lg"
            onClick={() => alert("Open Add Job Modal")}
          >
            + Add Opening
          </Button>
        </div>

        <Card>
          <table className="min-w-full bg-white rounded-xl shadow-md overflow-hidden">
            <thead className="bg-blue-50 text-blue-600 text-sm uppercase font-semibold">
              <tr>
                <th className="py-3 px-6 text-left">Position</th>
                <th className="py-3 px-6 text-left">Department</th>
                <th className="py-3 px-6 text-left">Job Type</th>
                <th className="py-3 px-6 text-left">Posted</th>
                <th className="py-3 px-6 text-center">Candidates</th>
                <th className="py-3 px-6 text-left">Status</th>
                <th className="py-3 px-6 text-center">Actions</th>
              </tr>
            </thead>

            <tbody className="text-gray-700 text-sm">
              {openings.map(job => (
                <tr
                  key={job.id}
                  className="border-b hover:bg-gray-50 transition duration-150"
                >
                  <td className="py-3 px-6 font-medium">{job.position}</td>
                  <td className="py-3 px-6">{job.department}</td>
                  <td className="py-3 px-6">{job.jobType}</td>
                  <td className="py-3 px-6">
                    {new Date(job.posted).toLocaleDateString()}
                  </td>

                  <td className="py-3 px-6 text-center font-semibold text-blue-600">
                    {job.candidates}
                  </td>

                  <td className="py-3 px-6">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusBadge(
                        job.status
                      )}`}
                    >
                      {job.status}
                    </span>
                  </td>

                  <td className="py-3 px-6 text-center">
                    <div className="flex justify-center gap-3">

                      <Button
                        className="bg-yellow-400 hover:bg-yellow-500 text-white px-3 py-1 rounded"
                        onClick={() => alert("Edit job")}
                      >
                        Edit
                      </Button>

                      <Button
                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                        onClick={() => alert("Delete job")}
                      >
                        Delete
                      </Button>

                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </HrLayout>
  );
}
